/**
 * Checks val is object (not array). Most reliable way
 */
export const isObject = (value: any): boolean =>
  Object.prototype.toString.call(value) === '[object Object]' && Boolean(value)

/**
 * Checks n is a integer number
 */
export const isInteger = (value: any): boolean =>
  Number.isFinite(value) && !/\d*\.\d*/.test(value)

/**
 * Check if passed value is number or not
 */
export const isNumber = (value: any): boolean =>
  typeof value === 'number' && !Number.isNaN(value - 0)
